import React from 'react';
import FeedPageContent from './FeedPageContent';
import { CollectionModal } from '../../hooks/useCollections';

const MobileBottomNav = () => (
  <div style={{ height: '100px' }}>
    <nav className="navbar fixed-bottom" id="navbarMobileBottom">
      <div id="changeBranchDropdownMobile">

      </div>
    </nav>
  </div>
);

const FeedPageLayout = ({
  country,
  searchQuery,
  onSearchChange,
  selectedAgency,
  onAgencySelect,
  hasAgencyFilter,
  buttonName,
  feedName,
  branch,
  topic,
  data,
  loading,
  error,
  schema,
  table,
  onLoadMore,
  collectionProps
}) => {
  const contentProps = {
    data,
    loading,
    error,
    schema,
    table,
    onLoadMore,
    buttonName,
    feedName,
    branch,
    topic
  };

  return (
    <>
      <div id="homebg">
        <FeedPageContent {...contentProps} />
        <CollectionModal {...collectionProps} />
      </div>
    </>
  );
};

export default FeedPageLayout;